import colors from "../../../Constants/colors";
import { tableStyles } from "../../../Constants/tableStyles";
import theme, { scrollbarStyles } from "../../../Constants/theme";

export const DeployedBotsContainerStyles = {
  display: "flex",
  flexDirection: "column",
  py: "10px",
  width: "100%",
  height: "100vh",
  color: colors.extremeWhite,
  px: 0,
};

export const DeployedBotsPaperStyles = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  my: "40px",
  padding: 6,
  overflowY: "hidden",
  height: "90vh",
  ...scrollbarStyles,
};
export const DeployedBotsTableContainerStyles = {
  overflowY: "auto",
  ...scrollbarStyles,
  marginTop: "20px",
  overflowX: "auto",
  borderRadius: 2,
  ...tableStyles.tableContainer,
};

export const textfieldLayout = {
  backgroundColor: colors.textFieldBackground,
  color: colors.extremeWhite,
  mr: 2,
  borderRadius: "25px", // Increase the border-radius for a rounder look
  borderColor: colors.tertiaryBlue,
  "& .MuiOutlinedInput-root": {
    padding: "1px 14px", // Adjust padding to reduce height
    fontSize: "0.875rem", // Adjust font size
    borderRadius: "25px", // Rounder corners inside the TextField
    "& fieldset": {
      borderColor: colors.tertiaryBlue,
    },
    "&:hover fieldset": {
      borderColor: colors.primaryBlue,
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.primaryBlue,
    },
    "&.Mui-disabled": {
      backgroundColor: colors.darkGray,
      color: colors.lightGray,
    },
  },
  input: {
    color: colors.extremeWhite,
    "&.Mui-disabled": {
      color: colors.lightGray,
    },
  },
};

export const ChatBoxMessagesStyles = {
  flex: 3,
  overflowY: "auto",
  mt: 1,
  width: "100%",
  WebkitOverflowScrolling: "touch", // For smooth scrolling on iOS
  scrollbarWidth: "thin", // For Firefox
  scrollbarColor: `${colors.secondaryBlue} ${colors.extremeBlack}`, // Custom scrollbar thumb and track colors
  "&::-webkit-scrollbar": {
    width: "8px", // Custom scrollbar width
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: colors.secondaryBlue, // Custom scrollbar thumb color
    borderRadius: "10px", // Rounding scrollbar edges
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: colors.extremeBlack, // Track background color
    borderRadius: "10px", // Round track edges for consistency
  },
  padding: 2,
};

export const HeaderButtonStyles = {
  color: colors.extremeWhite,
  bgcolor: colors.primaryBlue,
  ":hover": { bgcolor: colors.secondaryBlue },
  textTransform: "none !important",
  "&.Mui-disabled": {
    color: colors.lightGray,
    bgcolor: colors.secondaryBlue,
  },
};

export const textfieldLayoutNormal = {
  backgroundColor: colors.extremeWhite,
  borderRadius: "5px",
  // boxShadow: "0px 4px 12px var(--secondaryBlue)",
  "& .MuiInputBase-input": {
    color: colors.extremeBlack, // Ensure the text color inside the input is white
  },
  "& .MuiInputLabel-root.Mui-focused": {
    fontSize: "1.25rem",
    color: colors.extremeBlack,
  },
  "& .MuiInputLabel-root": {
    color: colors.extremeBlack,
  },
  border: `1px solid ${colors.primaryBlue}`,
};
export const btnStyles = {
  color: colors.extremeWhite,
  bgcolor: colors.primaryBlue,
  textTransform: "none",
  ":hover": {
    bgcolor: colors.secondaryBlue,
  },
  "&.Mui-disabled": {
    bgcolor: colors.darkGray, // Update this to your defined gray color
    color: colors.extremeWhite,
  },
};
